import React from "react";
import { useIntl } from "react-intl";

import CustomSelect from "src/app/components/CustomSelect/CustomSelect";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { MaterialTooltip } from "src/app/components/MaterialTooltip/MaterialTooltip";
import { getPercentOptions } from "../../utils/getPercentOptions";

export default function FollowersCountRange({
  influencerSocialUsername,
  paidPostPerformanceMin,
  setPaidPostPerformanceMin,
  audienceCredibilityScore,
  setAudienceCredibilityScore,
  influencerSocialProvider,
}) {
  const intl = useIntl();

  return (
    <div
      className="audience-search__field-box"
      data-qa="filter_credibility_and_paid_post_performance"
    >
      {(influencerSocialProvider?.value === "instagram" ||
        influencerSocialProvider === null) && (
        <div
          className="audience-search__field"
          data-filter-name="credibility_score"
        >
          <div className="idh-label idh-label--with-tooltip">
            <IDHFormattedMessage
              id="front_credibility_score"
              defaultMessage="Min. credibility score (%)"
            />
            <MaterialTooltip
              id="front_credibility_score_tooltip"
              content={
                <IDHFormattedMessage
                  id="front_credibility_score_tooltip"
                  defaultMessage="The parameter that determines how reliable the users following a given account are. The higher the parameter value, the more real and engaged the account's recipients are. Accounts with a credibility score equal to or higher than 60% are considered to be good."
                />
              }
            />
          </div>
          <CustomSelect
            placeholder={intl.formatMessage({
              id: "front_select_credibility_score",
              defaultMessage: "Select",
            })}
            isClearable
            value={audienceCredibilityScore}
            options={getPercentOptions(100)}
            onChange={(newValue) => setAudienceCredibilityScore(newValue)}
            isDisabled={influencerSocialUsername.length}
            dataAttr="min-credibility"
          />
        </div>
      )}
      {(influencerSocialProvider?.value === "instagram" ||
        influencerSocialProvider === null) && (
        <div
          className="audience-search__field"
          data-filter-name="paid_post_performance"
        >
          <div className="idh-label idh-label--with-tooltip">
            <IDHFormattedMessage
              id="front_paid_post_performance"
              defaultMessage="Min. paid post performance (%)"
            />
            <MaterialTooltip
              right
              content={
                <IDHFormattedMessage
                  id="front_paid_post_performance_tooltip"
                  defaultMessage="The parameter that determines how users' paid posts are performing."
                />
              }
            />
          </div>
          <CustomSelect
            placeholder={intl.formatMessage({
              id: "front_select_paid_post_performance",
              defaultMessage: "Select",
            })}
            isClearable
            value={paidPostPerformanceMin}
            options={getPercentOptions(200, 20)}
            onChange={(newValue) => setPaidPostPerformanceMin(newValue)}
            isDisabled={influencerSocialUsername.length}
            dataAttr="min-paid-post"
          />
        </div>
      )}
    </div>
  );
}
